angular.module('bizmetryApp').controller('UsersTabController', function (
    $scope, $mdDialog, $timeout, $mdToast,
    UserService, dialogService, ConfigurationService
) {

    // ── Init ──────────────────────────────────────────────────────────────────
    $scope.accountId = $scope.$parent.accountId;

    if (!$scope.accountId) {
        console.error('❌ Account ID not available in Users Tab');
        return;
    }

    $scope.loading      = true;
    $scope.users        = [];
    $scope.filteredUsers = [];
    $scope.roles        = [];

    // ── Two-step delete state ─────────────────────────────────────────────────
    // confirmDeleteMap[userId] = true  → fila en estado "pendiente de confirmar"
    $scope.confirmDeleteMap = {};
    var _deleteTimers = {};  // auto-reset timers por userId

    // ── Filters ───────────────────────────────────────────────────────────────
    $scope.filters = {
        name:        '',
        email:       '',
        userEnabled: null
    };

    // ── Pagination ────────────────────────────────────────────────────────────
    $scope.pagination = {
        currentPage:   0,
        pageSize:      10,
        totalPages:    0,
        totalElements: 0,
        sort:          'EMAIL_ASC',
        first:         true,
        last:          false,
        empty:         true
    };

    $scope.sortOptions = [
        { value: 'EMAIL_ASC',        label: 'Email (A-Z)'     },
        { value: 'EMAIL_DESC',       label: 'Email (Z-A)'     },
        { value: 'CREATION_TS_ASC',  label: 'Oldest First'    },
        { value: 'CREATION_TS_DESC', label: 'Newest First'    }
    ];

    $scope.statusOptions = [
        { value: null,  label: 'All Users'    },
        { value: true,  label: 'Active Only'  },
        { value: false, label: 'Disabled Only' }
    ];

    var debounceTimer;

    // ── Bootstrap ─────────────────────────────────────────────────────────────
    (function init() {
        loadRoles();
        loadFilteredUsers();
    })();

    // ── Load roles ────────────────────────────────────────────────────────────
    function loadRoles() {
        UserService.getScopedRoles($scope.accountId)
            .then(function (response) { $scope.roles = response.data || []; })
            .catch(function (err)      { console.error('❌ Error loading roles:', err); });
    }

    // ── Load users ────────────────────────────────────────────────────────────
    function loadFilteredUsers() {
        $scope.loading = true;

        var params = {
            page:  $scope.pagination.currentPage,
            size:  $scope.pagination.pageSize,
            sort:  $scope.pagination.sort,
            name:  $scope.filters.name  || undefined,
            email: $scope.filters.email || undefined
        };

        UserService.getUsersWithPagination($scope.accountId, params)
            .then(function (response) {
                var p = response.data;
                $scope.users                  = p.content       || [];
                $scope.pagination.totalElements = p.totalElements || 0;
                $scope.pagination.totalPages    = p.totalPages    || 0;
                $scope.pagination.currentPage   = p.currentPage   || 0;
                $scope.pagination.pageSize      = p.pageSize      || 10;
                $scope.pagination.first         = p.first         || false;
                $scope.pagination.last          = p.last          || false;
                $scope.pagination.empty         = p.empty         || false;

                applyStatusFilter();

                $timeout(function () { $scope.loading = false; }, 50);
            })
            .catch(function (err) {
                console.error('❌ Error fetching users:', err);
                $scope.users        = [];
                $scope.filteredUsers = [];
                $scope.pagination.totalElements = 0;
                $scope.pagination.totalPages    = 0;
                $scope.pagination.empty         = true;
                $mdToast.showSimple('❌ Error loading users');
                $timeout(function () { $scope.loading = false; }, 50);
            });
    }

    function applyStatusFilter() {
        var s = $scope.filters.userEnabled;
        $scope.filteredUsers = (s === null || s === undefined)
            ? $scope.users.slice()
            : $scope.users.filter(function (u) { return u.userEnabled === s; });
    }

    function updateUserLocally(userId, updates) {
        [$scope.users, $scope.filteredUsers].forEach(function (list) {
            var idx = list.findIndex(function (u) { return u.id === userId; });
            if (idx !== -1) angular.extend(list[idx], updates);
        });
    }

    // ── Filters & sorting ─────────────────────────────────────────────────────
    $scope.updateFilters = function () {
        if (debounceTimer) $timeout.cancel(debounceTimer);
        var delay = ConfigurationService.getFromCache('frontend.search_debounce_time') || 500;
        debounceTimer = $timeout(function () {
            $scope.pagination.currentPage = 0;
            loadFilteredUsers();
        }, delay);
    };

    $scope.applyFilters = function () {
        $scope.pagination.currentPage = 0;
        loadFilteredUsers();
    };

    $scope.clearFilters = function () {
        $scope.filters = { name: '', email: '', userEnabled: null };
        $scope.pagination.currentPage = 0;
        loadFilteredUsers();
    };

    $scope.onSortChange = function () {
        $scope.pagination.currentPage = 0;
        loadFilteredUsers();
    };

    $scope.onPageSizeChange = function () {
        $scope.pagination.currentPage = 0;
        loadFilteredUsers();
    };

    // ── Pagination ────────────────────────────────────────────────────────────
    $scope.previousPage = function () {
        if (!$scope.pagination.first) { $scope.pagination.currentPage--; loadFilteredUsers(); }
    };

    $scope.nextPage = function () {
        if (!$scope.pagination.last) { $scope.pagination.currentPage++; loadFilteredUsers(); }
    };

    // ── Edit / Create ─────────────────────────────────────────────────────────
    $scope.editUser = function (user) {
        UserService.getUserById(user.id, $scope.accountId)
            .then(function (response) {
                $mdDialog.show({
                    controller:          'UserEditDialogController',
                    templateUrl:         'home/main-menu/users/tabs/user-management/edit/user-edit-dialog.html',
                    parent:              angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose:       false,
                    multiple:            true,
                    locals: { user: response.data, roles: $scope.roles, accountId: $scope.accountId }
                }).then(function (updatedUser) {
                    if (updatedUser) {
                        $mdToast.showSimple('✅ User updated successfully');
                        updateUserLocally(updatedUser.id, updatedUser);
                    }
                });
            })
            .catch(function () {
                dialogService.showErrorDialog('Error Loading User', 'Could not load user data for editing.');
            });
    };

    $scope.createNewUser = function () {
        $mdDialog.show({
            controller:          'UserCreateDialogController',
            templateUrl:         'home/main-menu/users/tabs/user-management/create/user-create-dialog.html',
            parent:              angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose:       false,
            multiple:            true,
            locals: { roles: $scope.roles, accountId: $scope.accountId }
        }).then(function (newUser) {
            if (newUser) { $mdToast.showSimple('✅ User created successfully'); loadFilteredUsers(); }
        });
    };

    // ── Delete — 2-stage ──────────────────────────────────────────────────────
    //
    // Etapa 1 — primer click:
    //   Cambia el icono a estado "pendiente" (rojo pulsante, tooltip distinto).
    //   Se auto-resetea a los 3 s si no hay segundo click.
    //
    // Etapa 2 — segundo click:
    //   Abre un dialog que exige escribir el email exacto del usuario.
    //   Solo si coincide, se procede con la eliminación.
    //
    $scope.deleteUser = function (user) {
        if (user.isSuperUser) return;

        if (!$scope.confirmDeleteMap[user.id]) {
            // ── Etapa 1: activar estado pendiente ──────────────────────────
            $scope.confirmDeleteMap[user.id] = true;

            // Auto-reset a los 3 s
            if (_deleteTimers[user.id]) $timeout.cancel(_deleteTimers[user.id]);
            _deleteTimers[user.id] = $timeout(function () {
                $scope.confirmDeleteMap[user.id] = false;
            }, 3000);

        } else {
            // ── Etapa 2: confirmar con email via dialogService.showConfirmationDialog ──
            $timeout.cancel(_deleteTimers[user.id]);
            $scope.confirmDeleteMap[user.id] = false;

            dialogService.showConfirmationDialog(
                'Delete User',
                'This action is <strong>irreversible</strong>. ' +
                'User <strong>' + user.email + '</strong> and all associated data will be permanently deleted.',
                user.email,   // confirmationText: el usuario debe tipear el email exacto
                true          // dangerMode: tema rojo
            ).then(function (result) {
                if (result !== 'confirmed') return;

                UserService.deleteUser(user.id, $scope.accountId)
                    .then(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('✅ User ' + user.email + ' deleted')
                                .position('top right')
                                .hideDelay(3000)
                        );
                        loadFilteredUsers();
                    })
                    .catch(function (err) {
                        dialogService.showErrorDialog(
                            'Error Deleting User',
                            'Failed to delete user: ' + ((err.data && err.data.message) || err.message)
                        );
                    });
            });
        }
    };

    // ── Toggle status ─────────────────────────────────────────────────────────
    $scope.toggleUserStatus = function (user) {
        var newStatus = user.userEnabled;
        var action    = newStatus ? 'enable' : 'disable';

        UserService.patchUser(user.id, $scope.accountId, { userEnabled: newStatus })
            .then(function () {
                $mdToast.showSimple('✅ User ' + action + 'd successfully');
                updateUserLocally(user.id, { userEnabled: newStatus });
            })
            .catch(function (err) {
                user.userEnabled = !newStatus;
                dialogService.showErrorDialog('Error',
                    'Failed to ' + action + ' user: ' + ((err.data && err.data.message) || err.message));
            });
    };

    $scope.toggleUserConfirmed = function (user) {
        var newStatus = user.isConfirmed;
        UserService.patchUser(user.id, $scope.accountId, { isConfirmed: newStatus })
            .then(function () {
                $mdToast.showSimple('✅ User ' + (newStatus ? 'confirmed' : 'unconfirmed') + ' successfully');
                updateUserLocally(user.id, { isConfirmed: newStatus });
            })
            .catch(function (err) {
                user.isConfirmed = !newStatus;
                dialogService.showErrorDialog('Error', 'Failed to update confirmation status.');
            });
    };

    // ── Bulk actions ──────────────────────────────────────────────────────────
    $scope.enableAllUsers = function () {
        var targets = ($scope.users || []).filter(function (u) {
            return !u.isSuperUser && u.userEnabled === false;
        });
        if (!targets.length) { $mdToast.showSimple('⚠️ No disabled users to enable'); return; }

        dialogService.showDecisionDialog('Enable All Users',
            'Enable ALL ' + targets.length + ' disabled users? SuperUsers are unaffected.')
        .then(function (decision) {
            if (decision !== 'proceed') return;
            $scope.loading = true;
            UserService.enableAllUsers($scope.accountId)
                .then(function (r) {
                    $mdToast.showSimple('✅ Enabled ' + r.data.toggledCount + ' users');
                    loadFilteredUsers();
                })
                .catch(function (err) {
                    $scope.loading = false;
                    dialogService.showErrorDialog('Error', 'Failed to enable users.');
                });
        });
    };

    $scope.disableAllUsers = function () {
        var targets = ($scope.users || []).filter(function (u) {
            return !u.isSuperUser && u.userEnabled === true;
        });
        if (!targets.length) { $mdToast.showSimple('⚠️ No enabled users to disable'); return; }

        dialogService.showDecisionDialog('Disable All Users',
            'Disable ALL ' + targets.length + ' enabled users? SuperUsers are unaffected.')
        .then(function (decision) {
            if (decision !== 'proceed') return;
            $scope.loading = true;
            UserService.disableAllUsers($scope.accountId)
                .then(function (r) {
                    $mdToast.showSimple('✅ Disabled ' + r.data.toggledCount + ' users');
                    loadFilteredUsers();
                })
                .catch(function (err) {
                    $scope.loading = false;
                    dialogService.showErrorDialog('Error', 'Failed to disable users.');
                });
        });
    };

    // ── Resend confirmation email ─────────────────────────────────────────────
    $scope.resendConfirmationEmail = function (user) {
        UserService.resendConfirmationEmail(user.id, $scope.accountId)
            .then(function () {
                $mdToast.show($mdToast.simple()
                    .textContent('✅ Confirmation email sent to ' + user.email)
                    .position('top right').hideDelay(3000));
            })
            .catch(function (err) {
                dialogService.showErrorDialog('Error', 'Failed to send confirmation email.');
            });
    };

    // ── Helpers ───────────────────────────────────────────────────────────────
    $scope.getActiveCount   = function () { return ($scope.filteredUsers || []).filter(function (u) { return u.userEnabled === true; }).length; };
    $scope.getInactiveCount = function () { return ($scope.filteredUsers || []).filter(function (u) { return u.userEnabled === false; }).length; };
});